module.exports = __webpack_public_path__ + "img/6_72.676a9c58.png";